/**
 * React Application Root Component
 * i18n provider és routing beállítása
 */

import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n/i18n';
import {
  HomePage,
  ConversationPage,
  AdminLoginPage,
  AdminDashboardPage,
  AdminConversationDetailPage,
  RequirementsPage,
} from './pages';
import { ProtectedRoute } from './components';

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<HomePage />} />
          <Route path="/conversation/:id" element={<ConversationPage />} />
          
          {/* Admin Login (Public) */}
          <Route path="/admin/login" element={<AdminLoginPage />} />
          
          {/* Protected Admin Routes */}
          <Route element={<ProtectedRoute />}>
            <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
            <Route path="/admin/conversations/:id" element={<AdminConversationDetailPage />} />
            <Route path="/admin/requirements" element={<RequirementsPage />} />
            <Route path="/admin/requirements/:id" element={<RequirementsPage />} />
          </Route>
          
          {/* 404 Not Found */}
          <Route
            path="*"
            element={
              <div className="min-h-screen flex items-center justify-center bg-gray-100 dark:bg-gray-900">
                <div className="text-center">
                  <h1 className="text-6xl font-bold text-gray-800 dark:text-gray-200 mb-4">
                    404
                  </h1>
                  <p className="text-xl text-gray-600 dark:text-gray-400 mb-8">
                    Page not found
                  </p>
                  <a
                    href="/"
                    className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
                  >
                    Go Home
                  </a>
                </div>
              </div>
            }
          />
        </Routes>
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
